export default class CacheFactory {
    // #region Vars
    _Host;
    _Cache = new Map();
    // #endregion
    // #region Constructor
    constructor(host) {
        this._Host = host;
    }
    // #endregion
    // #region Core
    contains(name) {
        return this._Cache.has(name);
    }
    getOrCreate(name, create) {
        if (!this._Cache.has(name)) {
            try {
                this._Cache.set(name, create());
            }
            catch (e) {
                utils.logError("Cache getOrCreate", name);
                return null;
            }
        }
        if (!this._Cache.has(name)) {
            return null;
        }
        else {
            return this._Cache.get(name);
        }
    }
    async getOrCreateAsync(name, create) {
        if (!this._Cache.has(name)) {
            try {
                let tResult = await create();
                this._Cache.set(name, tResult);
                return tResult;
            }
            catch (e) {
                utils.logError("Cache getOrCreate", name);
                return null;
            }
        }
        else {
            return this._Cache.get(name);
        }
    }
}
